import React from 'react';
import { Button } from './ui/button';
import { Calendar, ArrowRight } from 'lucide-react';

const ConsultationBanner = ({ onOpenModal }) => {
  return (
    <section 
      className="py-20 relative overflow-hidden"
      style={{
        backgroundImage: 'linear-gradient(rgba(107, 27, 77, 0.9), rgba(45, 27, 61, 0.9)), url(https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=1920&q=80)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed',
      }}
    >
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto text-center text-white">
          <Calendar className="mx-auto mb-6 text-[#DC143C]" size={64} />
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            Book a Free Consultation
          </h2>
          <p className="text-xl mb-8 leading-relaxed opacity-90">
            Receive expert advice from our business consultants, well-versed in all aspects of UAE business setup. Operating from Chennai, we'll handle your UAE registration, licensing, and legal processes while giving you complete guidance.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button 
              size="lg"
              className="bg-[#DC143C] hover:bg-[#DC143C]/90 text-white px-8 py-6 text-lg rounded-lg shadow-xl hover:shadow-2xl transition-all group"
              onClick={onOpenModal}
            >
              Book Now
              <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" size={20} />
            </Button>
            <Button 
              size="lg"
              variant="outline"
              className="border-2 border-white text-white hover:bg-white hover:text-[#6B1B4D] px-8 py-6 text-lg rounded-lg transition-all"
              onClick={onOpenModal}
            >
              Call +971 52 866 2076
            </Button>
          </div>
        </div>
      </div>

      {/* Decorative Elements */}
      <div className="absolute top-10 left-10 w-32 h-32 border-4 border-white/20 rounded-full"></div>
      <div className="absolute bottom-10 right-10 w-48 h-48 border-4 border-white/20 rounded-full"></div>
    </section>
  );
};

export default ConsultationBanner;